import { useAuthContext, AuthStatus } from '@space-shell/common/contexts/auth'
import { UserInfoRole } from '@space-shell/common/services/user'
import { useAuthStore, useUserInfoStore, useViewAsStore, RoleType } from '@space-shell/core/store'

export function useAuthState() {
  const { authStatus } = useAuthContext()
  const { id: userId, userName } = useAuthStore()
  const { role: userRole } = useUserInfoStore()
  const { role: viewAsRole, isEnabled: isViewAsEnabled } = useViewAsStore()
  const isAuthenticating = authStatus === AuthStatus.AUTHENTICATING
  const isAuthenticated = authStatus === AuthStatus.AUTHENTICATED
  const isOwner = userRole === UserInfoRole.OWNER
  const shouldShowUnauthenticatedHeader =
    !isAuthenticated ||
    (isAuthenticated && isOwner && isViewAsEnabled && viewAsRole === RoleType.UserLogout)

  return {
    authStatus,
    isAuthenticating,
    isAuthenticated,
    userId,
    userName,
    shouldShowUnauthenticatedHeader
  }
}
